import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_KnFabButton = _resolveComponent("KnFabButton")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_Message = _resolveComponent("Message")
  const _component_QBEFilterCard = _resolveComponent("QBEFilterCard")
  const _component_QBEFilterParameters = _resolveComponent("QBEFilterParameters")
  const _component_Button = _resolveComponent("Button")
  const _component_QBETemporalFilterDialog = _resolveComponent("QBETemporalFilterDialog")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    id: "qbe-filter-dialog",
    class: "p-fluid kn-dialog--toolbar--primary",
    style: _ctx.QBEFilterDialogDescriptor.dialog.style,
    visible: _ctx.visible,
    modal: true,
    closable: false
  }, {
    header: _withCtx(() => [
      _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary p-p-0 p-m-2 p-col-12" }, {
        start: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.filters')), 1)
        ]),
        end: _withCtx(() => [
          _withDirectives(_createVNode("i", {
            class: "fa fa-calendar kn-cursor-pointer p-mr-4",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openTemporalFilterDialog && _ctx.openTemporalFilterDialog(...args)))
          }, null, 512), [
            [_vShow, _ctx.temporalFiltersEnabled()]
          ]),
          _createVNode(_component_KnFabButton, {
            icon: "fas fa-plus",
            onClick: _ctx.addNewFilter
          }, null, 8, ["onClick"])
        ]),
        _: 1
      })
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_Button, {
        class: "kn-button kn-button--primary",
        onClick: _ctx.closeDialog
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.cancel')), 1)
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_Button, {
        class: "kn-button kn-button--primary",
        onClick: _ctx.save
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.parameterTableVisible ? _ctx.$t('qbe.filters.applyParameters') : _ctx.$t('common.save')), 1)
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    default: _withCtx(() => [
      (_ctx.filters.length === 0 && !_ctx.parameterTableVisible)
        ? (_openBlock(), _createBlock(_component_Message, {
            key: 0,
            class: "p-m-4",
            severity: "info",
            closable: false,
            style: _ctx.QBEFilterDialogDescriptor.styles.message
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('common.info.noDataFound')), 1)
            ]),
            _: 1
          }, 8, ["style"]))
        : (!_ctx.parameterTableVisible)
          ? (_openBlock(), _createBlock("div", _hoisted_1, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.filters, (filter) => {
                return (_openBlock(), _createBlock(_component_QBEFilterCard, {
                  key: filter.filterId,
                  propFilter: filter,
                  id: _ctx.id,
                  propEntities: _ctx.entities,
                  subqueries: _ctx.filterDialogData?.query.subqueries,
                  field: _ctx.filterDialogData?.field,
                  propParameters: _ctx.parameters,
                  onRemoveFilter: _ctx.removeFilter
                }, null, 8, ["propFilter", "id", "propEntities", "subqueries", "field", "propParameters", "onRemoveFilter"]))
              }), 128))
            ]))
          : (_ctx.parameterTableVisible)
            ? (_openBlock(), _createBlock(_component_QBEFilterParameters, {
                key: 2,
                propParameters: _ctx.parameters,
                onParametersUpdated: _ctx.onParametersUpdated
              }, null, 8, ["propParameters", "onParametersUpdated"]))
            : _createCommentVNode("", true),
      _createVNode(_component_QBETemporalFilterDialog, {
        visible: _ctx.temporalFilterDialogVisible,
        temporalFilters: _ctx.temporalFilters,
        onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.temporalFilterDialogVisible = false)),
        onSave: _ctx.addTemporalFilter
      }, null, 8, ["visible", "temporalFilters", "onSave"])
    ]),
    _: 1
  }, 8, ["style", "visible"]))
}